export function dummyValue<T extends object>(): T {
  return new Proxy({} as T, {
    get(): never {
      throw new Error('Uninitialized context');
    },
  });
}
